import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedStoreState {
  storeId: string;
}

const initialState: SelectedStoreState = {
  storeId: 'all',
};

const selectedStoreSlice = createSlice({
  name: 'selectedStore',
  initialState,
  reducers: {
    setSelectedStore: (state, action: PayloadAction<string>) => {
      state.storeId = action.payload;
    },
    resetSelectedStore: (state) => {
      state.storeId = 'all';
    },
  },
});

export const { setSelectedStore, resetSelectedStore } = selectedStoreSlice.actions;
export default selectedStoreSlice.reducer;